<template>
  <div class="container module">
    <page-header type="image" :height="750" :image="banner">
      <template v-slot:searchbox>
        <div class="search-form">
          <div class="title">Video</div>
          <el-input style="width: 350px" placeholder="Keywords"></el-input>
        </div>
      </template>
    </page-header>

    <div class="navi">
      <page-navbar class="inn" />
    </div>

    <filters
      :showFilter="showFilter"
      type="simple"
      :items="video_types"
      :total="total"
      @resetItems="resetItems"
      @searchItems="searchItems"
      @toggleStatus="toggleFilterFormStatus"
    >
    </filters>

    <video-list :items="items" />

    <div class="section">
      <div class="loadmore" v-if="hasmore">
        <div class="btn" @click="loadMore">Load More</div>
      </div>
    </div>

    <page-footer />
  </div>
</template>
<style lang="scss" scoped>
.module {
  background-color: #fff;
}

.navi {
  position: relative;
  display: flex;
  justify-content: center;

  .inn {
    margin-top: -75px;
  }
}
</style>

<script>
import PageFooter from "../components/PageFooter.vue";
import PageHeader from "../components/PageHeaderV2.vue";
import PageNavbar from "../components/PageNavbar.vue";
import Filters from "../components/Filters.vue";
import VideoList from "../components/VideoList.vue";
import { mapGetters } from "vuex";
import Api from "../utils/api";

export default {
  name: "Video",
  components: {
    PageFooter,
    PageHeader,
    PageNavbar,
    Filters,
    VideoList,
  },
  methods: {
    resetItems() {
      this.showFilter = false;
    },
    loadMore() {
      if (this.hasmore) {
        let pg = this.pg + 1;
        this.queryList({ pg });
      }
    },
    searchItems() {},

    toggleFilterFormStatus() {
      this.showFilter = !this.showFilter;
    },

    queryList(args) {
      Api.getVideoList(args)
        .then((res) => {
          let items = this.items;
          this.items = items.concat(res.items);
          this.total = res.total;
          this.hasmore = res.hasmore;
          this.pg = Number(res.pg);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
  computed: {
    ...mapGetters({
      cats: "getProductCats",
      video_types: "getVideoTypes",
      module_types: "getModuleTypes",
      getPageData: "getPageData",
    }),
    banner() {
      let key = "videos";
      let page = this.getPageData;
      return !!page[key] ? page[key] : false;
    },
  },

  created() {
    this.queryList({ pg: 1 });
  },

  data() {
    return {
      showFilter: false,
      brand: "",
      hasmore: false,
      total: 0,
      items: [],
    };
  },
};
</script>
